import { render, staticRenderFns } from "./DoctorsRegistered.html?vue&type=template&id=9cbce18a&external"
import script from "./DoctorsRegistered.vue?vue&type=script&lang=js"
export * from "./DoctorsRegistered.vue?vue&type=script&lang=js"
import style0 from "./DoctorsRegistered.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports